import React, { useState, useEffect, useCallback } from 'react'

import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Icon } from 'antd'

import { validRule, RULES } from '../../../constants/Entitlements'
import { api, request } from '../../../util/handlerRequestUtil'
import DataTable from '../../../components/DataTable/DataTable'
import { exportCSV, exportExcel } from '../../../util/exportUtils'
import Header from './Header'
import { maskedCnpj, maskedCpf } from '../../../util/document'

const ListCustomer = function ({ history }) {
  const [customersList, setCustomersList] = useState([])
  const [customersCount, setCustomersCount] = useState(0)
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    areaTotal: { value: null, matchMode: FilterMatchMode.CONTAINS },
    qntdfazenda: { value: null, matchMode: FilterMatchMode.CONTAINS },
    isEibText: { value: null, matchMode: FilterMatchMode.CONTAINS },
    documentNumber: { value: null, matchMode: FilterMatchMode.CONTAINS }
  })
  const [globalFilterValue, setGlobalFilterValue] = useState('')

  useEffect(() => {
    const hasAccess = validRule(RULES.CUSTOMER)
    if (!hasAccess) {
      return history.push('/home')
    }

    async function fetchData() {
      await getCustomers()
    }
    fetchData()
  }, [])

  const getCustomers = useCallback(async (params) => {
    const data = await request(api.listCustomersViewAgricultores({ ...params }))
    setCustomersList(formatAlternatives(data))
    setCustomersCount(data.length)
  }, [])

  const formatAlternatives = (data) => {
    return data.map(({ documentNumber, ...rest }) => {
      if (/^\d+$/.test(documentNumber)) {
        return {
          ...rest,
          documentNumber: documentNumber.length < 12 ? maskedCpf(documentNumber) : maskedCnpj(documentNumber)
        }
      }

      return { ...rest, documentNumber }
    })
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    let _filters = { ...filters }

    _filters['global'].value = value

    setFilters(_filters)
    setGlobalFilterValue(value)
  }

  const exportCSVData = () => {
    exportCSV(customersList, 'lista_de_agricultores')
  }

  const exportExcelData = () => {
    exportExcel(customersList, 'lista_de_agricultores')
  }

  const editBodyTemplate = ({ id }) => {
    return (
      <Button className="p-button-text" onClick={() => history.push(`/customer/${id}`)}>
        <Icon type="edit" className="default-actionContent-icon" />
      </Button>
    )
  }

  const columns = [
    { header: 'Nome', field: 'name', filterField: 'name', responsive: true },
    { header: 'Tipo', field: 'tipo', filterField: 'tipo', responsive: true },
    { header: 'Area Total', field: 'areaTotal', filterField: 'areaTotal', responsive: true },
    { header: 'Quantidade Fazendas', field: 'qntdfazenda', filterField: 'qntdfazenda', responsive: true },
    { header: 'CPF / CNPJ', field: 'documentNumber', filterField: 'documentNumber', responsive: true },
    { header: 'Participante EIB', field: 'isEibText', filterField: 'isEibText', responsive: true },
    { header: 'Editar', body: editBodyTemplate, width: '5rem', responsive: true }
  ]

  return (
    <div className="card">
      <Header
        exportCSV={exportCSVData}
        exportExcelData={exportExcelData}
        history={history}
        customersCount={customersCount}
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
        getWalletCustomers={getCustomers}
      />
      <DataTable itemsList={customersList} filters={filters} columns={columns} emptyMessage="emptyCustomer" />
    </div>
  )
}

export default ListCustomer
